module.exports = __webpack_public_path__ + "static/media/MTL_GOLD3.c6eb87af.png";